import { getRequest } from "./serviceHelpers";

/**
 * API requests for Status Page management
 */
export default {
  // Getters
  load: async (slug) => getRequest(`/status-pages/public/${slug}`),
};
